/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import * as stylex from '@stylexjs/stylex';

export const $ = stylex.defineVars({
  colorGray00: '#FFFFFFFF',
  colorGray05: '#F8F8FBFF',
  colorGray10: '#F3F3F3FF',
  colorGray15: '#EAEAEAFF',
  colorGray20: '#DCDCDCFF',
  colorGray25: '#CBCBCBFF',
  colorGray30: '#B2B2B2FF',
  colorGray40: '#9E9E9EFF',
  colorGray50: '#878787FF',
  colorGray60: '#696969FF',
  colorGray70: '#636363FF',
  colorGray80: '#515258FF',
  colorGray90: '#38393FFF',
  colorGray100: '#0A0A0AFF',
  colorBlue00: '#E9EFF9FF',
  colorBlue05: '#E5EAFDFF',
  colorBlue10: '#D4DFFFFF',
  colorBlue15: '#A8BBFFFF',
  colorBlue20: '#93A8FFFF',
  colorBlue30: '#6F87FFFF',
  colorBlue40: '#516DFFFF',
  colorBlue50: '#4D63FDFF',
  colorBlue60: '#3F51F4FF',
  colorBlue70: '#2936E3FF',
  colorBlue80: '#2027C3FF',
  colorBlue90: '#171991FF',
  colorBlue100: '#101066FF',
  colorRed00: '#FFEAEAFF',
  colorRed05: '#FCD3CFFF',
  colorRed50: '#CD3535FF',
  colorRed70: '#7D1A1AFF',
  colorRed80: '#6F1212FF',
  colorRed90: '#4D0A0AFF',
  colorGreen00: '#DFF2E5FF',
  colorGreen05: '#CDE8D5FF',
  colorGreen50: '#4AAA69FF',
  colorGreen60: '#288344FF',
  colorGreen70: '#1D6F37FF',
  colorYellow00: '#FFF7E0FF',
  colorYellow05: '#FFEBACFF',
  colorYellow50: '#F2CC22FF',
  colorCucumber10: '#00C74124',
  colorCucumber60: '#1FBB54FF',
  colorCucumber80: '#177335FF',
  opacity02: '#00000005',
  opacity04: '#0000000A',
  opacity06: '#0000000F',
  opacity08: '#00000014',
  opacity10: '#0000001A',
  opacity12: '#0000001F',
  opacity14: '#FFFFFFFF',
  opacity16: '#00000029',
  opacity20: '#00000033',
  opacity24: '#0000003D',
  opacity28: '#00000047',
  opacity32: '#00000052',
  opacity40: '#00000066',
  opacity48: '#0000007A',
  opacity64: '#000000A3',
  opacity72: '#000000B8',
  opacity80: '#000000CC',
  opacity88: '#000000E0',
  opacity96: '#000000F5',
  colorTurquoise10: '#00C6BF29',
  colorTurquoise60: '#00B8B2FF',
  colorTurquoise80: '#007773FF',
  colorOcean05: '#00A4EA14',
  colorOcean10: '#00A4EA24',
  colorOcean15: '#00A4EA38',
  colorOcean60: '#00ABF5FF',
  colorOcean80: '#006D9CFF',
  colorSky10: '#0060FF1F',
  colorSky60: '#307EFFFF',
  colorSky80: '#375FC4FF',
  colorPlum10: '#5600C221',
  colorPlum60: '#8A2BFFFF',
  colorPlum80: '#6635A3FF',
  colorChilli10: '#FF1F001F',
  colorChilli60: '#FF4B32FF',
  colorChilli80: '#CD3535FF',
  colorPumpkin10: '#FF950133',
  colorPumpkin60: '#FF7B01FF',
  colorPumpkin80: '#B55700FF',
  colorBeetroot10: '#AF939D33',
  colorBeetroot60: '#AF939DFF',
  colorBeetroot80: '#7C4D5EFF',
  colorSun00: '#FFF7E0FF',
  colorSun05: '#FFBD001F',
  colorSun10: '#FFBD0038',
  colorSun60: '#F0B200FF',
  colorSun80: '#725C00FF',
  colorYellow60: '#F0B200FF',
  colorYellow80: '#725C00FF',
  shadowBottom010Loud: '0px 1px 1px 0px rgba(0, 0, 0, 0.16)',
  shadowBottom010Medium: '0px 1px 1px 0px rgba(0, 0, 0, 0.06)',
  shadowBottom010Silent: '0px 1px 1px 0px rgba(0, 0, 0, 0.04)',
  shadowBottom020Loud: '0px 1px 2px 0px rgba(0, 0, 0, 0.18)',
  shadowBottom020Medium: '0px 1px 2px 0px rgba(0, 0, 0, 0.08)',
  shadowBottom020Silent: '0px 1px 2px 0px rgba(0, 0, 0, 0.04)',
  shadowBottom030Loud: '0px 1.5px 3px 0px rgba(0, 0, 0, 0.16)',
  shadowBottom030Medium: '0px 1.5px 3px 0px rgba(0, 0, 0, 0.06)',
  shadowBottom030Silent: '0px 1.5px 3px 0px rgba(0, 0, 0, 0.03)',
  shadowBottom040Loud: '0px 2.5px 5px 0px rgba(0, 0, 0, 0.12)',
  shadowBottom040Medium: '0px 2.5px 5px 0px rgba(0, 0, 0, 0.05)',
  shadowBottom040Silent: '0px 2.5px 5px 0px rgba(0, 0, 0, 0.03)',
  shadowBottom050Loud: '0px 3px 10px 0px rgba(0, 0, 0, 0.12)',
  shadowBottom050Medium: '0px 3px 10px 0px rgba(0, 0, 0, 0.05)',
  shadowBottom050Silent: '0px 4px 12px 0px rgba(0, 0, 0, 0.03)',
  shadowBottom060Loud: '0px 4px 12px 0px rgba(0, 0, 0, 0.12)',
  shadowBottom060Medium: '0px 4px 12px 0px rgba(0, 0, 0, 0.05)',
  shadowBottom060Silent: '0px 2px 6px 0px rgba(0, 0, 0, 0.03)',
  shadowBottom070Loud: '0px 20px 40px 0px rgba(0, 0, 0, 0.12)',
  shadowBottom070Medium: '0px 20px 40px 0px rgba(0, 0, 0, 0.07)',
  shadowBottom070Silent: '0px 20px 40px 0px rgba(0, 0, 0, 0.04)',
  shadowBottom080Loud: '0px 32px 48px 0px rgba(0, 0, 0, 0.12)',
  shadowBottom080Medium: '0px 32px 48px 0px rgba(0, 0, 0, 0.09)',
  shadowBottom080Silent: '0px 32px 48px 0px rgba(0, 0, 0, 0.05)',
  shadowBottom090Loud: '0px 48px 72px 0px rgba(0, 0, 0, 0.12)',
  shadowBottom090Medium: '0px 48px 72px 0px rgba(0, 0, 0, 0.08)',
  shadowBottom090Silent: '0px 48px 72px 0px rgba(0, 0, 0, 0.04)',
  shadowCenter010Loud: '0px 0px 1px 0px rgba(0, 0, 0, 0.36)',
  shadowCenter010Medium: '0px 0px 1px 1px rgba(0, 0, 0, 0.24)',
  shadowCenter010Silent: '0px 0px 1px 1px rgba(0, 0, 0, 0.16)',
  shadowCenter020Loud: '0px 0px 2px 0px rgba(0, 0, 0, 0.24)',
  shadowCenter020Medium: '0px 0px 2px 0px rgba(0, 0, 0, 0.16)',
  shadowCenter020Silent: '0px 0px 2px 0px rgba(0, 0, 0, 0.10)',
  shadowCenter030Loud: '0px 0px 3px 0px rgba(0, 0, 0, 0.20)',
  shadowCenter030Medium: '0px 0px 3px 0px rgba(0, 0, 0, 0.10)',
  shadowCenter030Silent: '0px 0px 3px 0px rgba(0, 0, 0, 0.07)',
  shadowCenter040Loud: '0px 0px 10px 0px rgba(0, 0, 0, 0.16)',
  shadowCenter040Medium: '0px 0px 10px 0px rgba(0, 0, 0, 0.08)',
  shadowCenter040Silent: '0px 0px 10px 0px rgba(0, 0, 0, 0.04)',
  shadowCenter050Loud: '0px 0px 14px 0px rgba(0, 0, 0, 0.12)',
  shadowCenter050Medium: '0px 0px 14px 0px rgba(0, 0, 0, 0.08)',
  shadowCenter050Silent: '0px 0px 14px 0px rgba(0, 0, 0, 0.04)',
  shadowCenter060Loud: '0px 0px 12px 0px rgba(0, 0, 0, 0.12)',
  shadowCenter060Medium: '0px 0px 12px 0px rgba(0, 0, 0, 0.08)',
  shadowCenter060Silent: '0px 0px 12px 0px rgba(0, 0, 0, 0.05)',
  shadowCenter070Loud: '0px 0px 40px 0px rgba(0, 0, 0, 0.12)',
  shadowCenter070Medium: '0px 0px 40px 0px rgba(0, 0, 0, 0.10)',
  shadowCenter070Silent: '0px 0px 40px 0px rgba(0, 0, 0, 0.06)',
  shadowCenter080Loud: '0px 0px 48px 0px rgba(0, 0, 0, 0.12)',
  shadowCenter080Medium: '0px 0px 48px 0px rgba(0, 0, 0, 0.12)',
  shadowCenter080Silent: '0px 0px 48px 0px rgba(0, 0, 0, 0.05)',
  shadowCenter090Loud: '0px 0px 72px 0px rgba(0, 0, 0, 0.12)',
  shadowCenter090Medium: '0px 0px 72px 0px rgba(0, 0, 0, 0.10)',
  shadowCenter090Silent: '0px 0px 72px 0px rgba(0, 0, 0, 0.04)',
  shadowTop010Loud: '0px -1px 1px 0px rgba(0, 0, 0, 0.16)',
  shadowTop010Medium: '0px -1px 1px 0px rgba(0, 0, 0, 0.06)',
  shadowTop010Silent: '0px -1px 1px 0px rgba(0, 0, 0, 0.04)',
  shadowTop020Loud: '0px -1px 2px 0px rgba(0, 0, 0, 0.18)',
  shadowTop020Medium: '0px -1px 2px 0px rgba(0, 0, 0, 0.08)',
  shadowTop020Silent: '0px -1px 2px 0px rgba(0, 0, 0, 0.04)',
  shadowTop030Loud: '0px -1.5px 3px 0px rgba(0, 0, 0, 0.16)',
  shadowTop030Medium: '0px -1.5px 3px 0px rgba(0, 0, 0, 0.06)',
  shadowTop030Silent: '0px -1.5px 3px 0px rgba(0, 0, 0, 0.03)',
  shadowTop040Loud: '0px -2.5px 5px 0px rgba(0, 0, 0, 0.12)',
  shadowTop040Medium: '0px -2.5px 5px 0px rgba(0, 0, 0, 0.05)',
  shadowTop040Silent: '0px -2.5px 5px 0px rgba(0, 0, 0, 0.03)',
  shadowTop050Loud: '0px -3px 10px 0px rgba(0, 0, 0, 0.12)',
  shadowTop050Medium: '0px -3px 10px 0px rgba(0, 0, 0, 0.05)',
  shadowTop050Silent: '0px -3px 10px 0px rgba(0, 0, 0, 0.03)',
  shadowTop060Loud: '0px -4px 12px 0px rgba(0, 0, 0, 0.12)',
  shadowTop060Medium: '0px -4px 12px 0px rgba(0, 0, 0, 0.05)',
  shadowTop060Silent: '0px -4px 12px 0px rgba(0, 0, 0, 0.03)',
  shadowTop070Loud: '0px -20px 40px 0px rgba(0, 0, 0, 0.12)',
  shadowTop070Medium: '0px -20px 40px 0px rgba(0, 0, 0, 0.07)',
  shadowTop070Silent: '0px -20px 40px 0px rgba(0, 0, 0, 0.04)',
  shadowTop080Loud: '0px -32px 48px 0px rgba(0, 0, 0, 0.12)',
  shadowTop080Medium: '0px -32px 48px 0px rgba(0, 0, 0, 0.09)',
  shadowTop080Silent: '0px -32px 48px 0px rgba(0, 0, 0, 0.05)',
  shadowTop090Loud: '0px -48px 72px 0px rgba(0, 0, 0, 0.12)',
  shadowTop090Medium: '0px -48px 72px 0px rgba(0, 0, 0, 0.08)',
  shadowTop090Silent: '0px -48px 72px 0px rgba(0, 0, 0, 0.04)',
  textPrimary: '#0A0A0AFF',
  textSecondary: '#515258FF',
  textTertiary: '#696969FF',
  textQuaternary: '#878787FF',
  textPlaceholder: '#9E9E9EFF',
  textDisabled: '#DCDCDCFF',
  textInverted: '#FFFFFFFF',
  textInteractive: '#4D63FDFF',
  textInteractiveHover: '#2936E3FF',
  textCritical: '#CD3535FF',
  textCriticalHover: '#7D1A1AFF',
  textWhite: '#FFFFFFFF',
  textBlack: '#0A0A0AFF',
  textPositive: '#288344FF',
  textPositiveHover: '#1D6F37FF',
  iconPrimary: '#0A0A0AFF',
  iconSecondary: '#636363FF',
  iconTertiary: '#878787FF',
  iconQuaternary: '#B2B2B2FF',
  iconDisabled: '#DCDCDCFF',
  iconInverted: '#FFFFFFFF',
  iconInteractive: '#4D63FDFF',
  iconPositive: '#288344FF',
  iconAttentive: '#F2CC22FF',
  iconDestructive: '#CD3535FF',
  iconWhite: '#FFFFFFFF',
  iconBlack: '#0A0A0AFF',
  border04: '#0000000A',
  border06: '#0000000F',
  border08: '#00000014',
  border10: '#0000001A',
  border12: '#0000001F',
  border16: '#00000029',
  border20: '#00000033',
  border24: '#0000003D',
  borderContrast: '#0A0A0AFF',
  borderContrastInverted: '#FFFFFFFF',
  borderInteractive: '#3F51F4FF',
  borderInteractiveSilent: '#D4DFFFFF',
  borderPositive: '#4AAA69FF',
  borderAttentive: '#F2CC22FF',
  borderCritical: '#CD3535FF',
  borderBlack: '#0A0A0AFF',
  borderWhite: '#FFFFFFFF',
  surfaceBGPrimary: '#FFFFFFFF',
  surfaceBGSecondary: '#F8F8FBFF',
  surfaceBGAlternative01: '#FFFFFFFF',
  surfaceBGAlternative02: '#F8F8FBFF',
  surface00: '#FFFFFFFF',
  surface01: '#F8F8FBFF',
  surface02: '#F3F3F3FF',
  surface03: '#EAEAEAFF',
  surface04: '#DCDCDCFF',
  surface05: '#CBCBCBFF',
  surfaceContrast: '#0A0A0AFF',
  surfaceContrastInverted: '#FFFFFFFF',
  surfaceBlack: '#0A0A0AFF',
  surfaceWhite: '#FFFFFFFF',
  surfaceHighlight: '#516DFFFF',
  surfaceHighlightMedium: '#E5EAFDFF',
  surfaceHighlightSilent: '#E9EFF9FF',
  surfacePositive: '#4AAA69FF',
  surfacePositiveMedium: '#DFF2E5FF',
  surfacePositiveSilent: '#DFF2E5FF',
  surfaceAttentive: '#F2CC22FF',
  surfaceAttentiveMedium: '#FFEBACFF',
  surfaceAttentiveSilent: '#FFF7E0FF',
  surfaceCritical: '#CD3535FF',
  surfaceCriticalMedium: '#FCD3CFFF',
  surfaceCriticalSilent: '#FFEAEAFF',
  opacity10Inverted: '#FFFFFF1A',
  accentSun10: '#FFF7E0FF',
  accentSun60: '#F0B200FF',
  accentSun80: '#725C00FF',
  accentPumpkin10: '#FF950133',
  opacity12Inverted: '#FFFFFF1F',
  opacity32Inverted: '#FFFFFF52',
  accentPumpkin60: '#FF7B01FF',
  accentPumpkin80: '#B55700FF',
  accentChilli10: '#FF1F001F',
  accentChilli60: '#FF4B32FF',
  accentChilli80: '#CD3535FF',
  accentPlum10: '#5600C221',
  buttonContentPrimary: '#FFFFFFFF',
  accentPlum60: '#8A2BFFFF',
  accentPlum80: '#6635A3FF',
  accentSky10: '#0060FF1F',
  buttonContentPrimaryHover: '#FFFFFFFF',
  accentSky60: '#307EFFFF',
  accentSky80: '#375FC4FF',
  buttonContentPrimaryMono: '#FFFFFFFF',
  buttonContentPrimaryMonoHover: '#FFFFFFFF',
  buttonContentSecondary: '#0A0A0AFF',
  buttonContentSecondaryHover: '#0A0A0AFF',
  buttonContentTertiary: '#3F51F4FF',
  buttonContentTertiaryHover: '#3F51F4FF',
  buttonContentQuaternary: '#696969FF',
  buttonContentQuaternaryHover: '#515258FF',
  buttonContentAlternative: '#0A0A0AFF',
  buttonContentAlternativeHover: '#0A0A0AFF',
  buttonContentGhostPrimary: '#9E9E9EFF',
  buttonContentGhostSecondary: '#CBCBCBFF',
  buttonContentGhostHover: '#3F51F4FF',
  buttonContentGhostDestructiveHover: '#CD3535FF',
  buttonContentDisabled: '#00000029',
  buttonSurfacePrimary: '#3F51F4FF',
  buttonSurfacePrimaryHover: '#2027C3FF',
  buttonSurfacePrimaryMono: '#0A0A0AFF',
  buttonSurfacePrimaryMonoHover: '#38393FFF',
  buttonSurfaceSecondary: '#0000000F',
  buttonSurfaceSecondaryHover: '#0000001A',
  buttonSurfaceTertiary: '#E9EFF9FF',
  buttonSurfaceTertiaryHover: '#D4DFFFFF',
  buttonSurfaceTertiaryPressed: '#D4DFFFFF',
  accentOcean10: '#00A4EA24',
  buttonSurfaceQuaternary: '#FFFFFFFF',
  buttonSurfaceQuaternaryHover: '#0000000F',
  buttonSurfaceAlternative: '#FFFFFFFF',
  buttonSurfaceAlternativeHover: '#EAEAEAFF',
  buttonSurfaceAttentive: '#F2CC22FF',
  buttonSurfaceCritical: '#CD3535FF',
  buttonSurfaceDisabled: '#0000000F',
  buttonSurfaceGhostHover: '#E5EAFDFF',
  buttonSurfaceGhostDestructiveHover: '#FFEAEAFF',
  opacity80Inverted: '#FFFFFFCC',
  accentOcean60: '#00ABF5FF',
  accentOcean80: '#006D9CFF',
  accentTurquoise10: '#00C6BF29',
  accentTurquoise60: '#00B8B2FF',
  accentTurquoise80: '#007773FF',
  accentCucumber10: '#00C74124',
  accentCucumber60: '#1FBB54FF',
  accentCucumber80: '#177335FF',
  accentBeetroot10: '#AF939D33',
  accentBeetroot60: '#AF939DFF',
  accentBeetroot80: '#7C4D5EFF',
  opacity88Inverted: '#FFFFFFE0',
  tableRowBgAlternating: 'linear-gradient(0deg, rgba(0, 0, 0, 0.01) 0%, rgba(0, 0, 0, 0.01) 100%)',
});
